import React from "react";

import { motion } from "framer-motion";
import "./WhatWeDo.css";
import {FaComments,FaClipboardList,FaPaintBrush,FaCode,FaClipboardCheck,FaRocket}from 'react-icons/fa'


function StepsweFollow() {
  return (
    <section className="key-features" >
      <h2 id="key">Steps We Follow</h2>
      <div className="services-grid">
        {[ 
          { icon: <FaComments/>, title: "Onboarding & Discovery", text: "We get to know you and your brand. We explore your values, goals, and audience to lay a strong foundation for a strategy that truly reflects your culture." },
          { icon: <FaClipboardList/>, title: "Research & Strategy", text: "We plan with insight. By studying your market and audience, we create a strategy that resonates and maps out your campaigns, content, and website features." },
          { icon: <FaPaintBrush/>, title: "Content & Website Development", text: "We bring your story to life. From engaging posts and videos to a well-designed website, every piece captures attention and connects meaningfully with your audience." },
          { icon: <FaCode/>, title: "Campaign & Website Launch", text: "We make your brand shine online. We schedule posts, launch ads, and publish your website — all optimized to engage the right people while staying true to your brand story." },
          { icon: <FaClipboardCheck/>, title: "Community Engagement & Optimization", text: "We keep the conversation going. We interact with your audience and fine-tune campaigns to ensure relevance, engagement, and lasting relationships." },
          { icon: <FaRocket/>, title: " Reporting & Growth Planning", text: "We measure, learn, and grow together, Clear reports and insights. guide the next steps to scale your digital presence while keeping your brand authentic." }
        ].map((feature, index) => (
          <motion.div 
            className="service-item"
            key={index}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <span className="icon">{feature.icon}</span>
            <h3>{feature.title}</h3>
            <p>{feature.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default StepsweFollow;
